// extracted by mini-css-extract-plugin
export default {"job_admin":"Admin_job_admin__1kIWt","heading":"Admin_heading__Ll3a0","jobs":"Admin_jobs__uUDmd","add_job":"Admin_add_job__W6iWf"};